import React from 'react';
import HFHJSection8a from '../../../../course/churchschool/hfhj/HFHJSection8a';
import JepsplSection from '../../../../course/churchschool/JepsplSection';
import WarningSection from '../../../../course/churchschool/WarningSection';
import HFHJSection14 from '../../../../course/churchschool/hfhj/HFHJSection14';
import GodDealWeekSectionOct, {
  IS_DISPLAY_GODDEAL_SECTION,
} from '../../../../course/churchschool/event/GodDealWeekSectionOct';

const BoostupHFBookMain = () => {
  return (
    <>
      {IS_DISPLAY_GODDEAL_SECTION && <GodDealWeekSectionOct />}

      <HFHJSection8a />
      <WarningSection />
      <JepsplSection />
      <HFHJSection14 />
    </>
  );
};

export default BoostupHFBookMain;
